import { render, staticRenderFns } from "./nodeEntry.vue?vue&type=template&id=07c87570&scoped=true&"
import script from "./nodeEntry.vue?vue&type=script&lang=js&"
export * from "./nodeEntry.vue?vue&type=script&lang=js&"
import style0 from "./nodeEntry.vue?vue&type=style&index=0&id=07c87570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c87570",
  null
  
)

export default component.exports